module.exports = __webpack_public_path__ + "img/mail_envoi_carte_tp.3758d14f.svg";